import { UserOutlined } from '@ant-design/icons';
import { Avatar, AvatarProps } from 'antd';
import React, { useMemo } from 'react';
import { TitleLink } from '../styles';

interface ICandidateAvatar {
	showAvatar: boolean;
	candidate: any;
	onClick?: () => void;
	size?: any;
	avatarBgColor?: string;
	showCode?: boolean;
	link?: boolean;
	to?: string;
}

export const CandidateAvatar: React.FC<AvatarProps & ICandidateAvatar> = ({
	showAvatar,
	candidate,
	onClick,
	size = 32,
	avatarBgColor = null,
	shape = 'square',
	showCode = true,
	link = false,
	...restProps
}) => {
	const bgColor = useMemo(() => avatarBgColor || '#4ADCAA', [avatarBgColor]);
	const avatar = (
		<Avatar
			size={size}
			src={showAvatar ? candidate.avatar : null}
			icon={showAvatar ? null : <UserOutlined size={20} />}
			shape={shape}
			style={{
				backgroundColor: bgColor,
				flexShrink: 0
			}}
		>
			{showAvatar && (
				<span style={{ mixBlendMode: 'difference', fontSize: '2.5rem' }}>
					{candidate.nameInitials ||
						`${candidate.profile.firstName.toUpperCase()[0]}${candidate.profile.lastName.toUpperCase()[0]}`}
				</span>
			)}
		</Avatar>
	);
	return link ? (
		<TitleLink
			onClick={e => {
				// e.preventDefault();
				onClick && onClick();
			}}
			color="#3F536E"
			size={15}
			className="p-2 d-flex"
			{...restProps}
		>
			<div className="py-2 d-flex flex-column align-items-center ">
				{avatar}
				{showCode && <span>{candidate.code}</span>}
			</div>
		</TitleLink>
	) : (
		avatar
	);
};
